import * as React from "react";

import { motion } from "motion/react";

type NavItemWithAnnotationProps = React.PropsWithChildren<{
  label: string;
  lineHeight: number;
  delay: number;
  started: boolean;
}>;

export function NavItemWithAnnotation({
  children,
  label,
  lineHeight,
  delay,
  started,
}: NavItemWithAnnotationProps) {
  const delaySeconds = delay / 1000;

  return (
    <div className="relative">
      {children}
      {/* Annotation line and label */}
      <div className="pointer-events-none absolute left-1/2 top-full flex -translate-x-1/2 flex-col items-center">
        <motion.div
          initial={{ height: 0 }}
          animate={{ height: started ? lineHeight : 0 }}
          transition={{
            delay: delaySeconds,
            duration: 0.4,
            ease: [0.2, 0, 0.2, 1],
          }}
          style={{
            width: 1,
            backgroundImage:
              "repeating-linear-gradient(to bottom, #f5fad9 0, #f5fad9 4px, transparent 4px, transparent 8px)",
          }}
        />
        <motion.div
          className="absolute size-[7px] rounded-full bg-[#f5fad9]"
          initial={{ opacity: 0, top: 0 }}
          animate={{
            opacity: started ? 1 : 0,
            top: started ? lineHeight : 0,
          }}
          transition={{
            delay: delaySeconds,
            duration: 0.4,
            ease: [0.2, 0, 0.2, 1],
          }}
        />
        <motion.div
          className="absolute mt-2 min-w-[180px] whitespace-pre-line text-center text-sm font-medium leading-5 text-[#f5fad9]"
          initial={{ opacity: 0, top: 8 }}
          animate={{
            opacity: started ? 1 : 0,
            top: started ? lineHeight + 8 : 8,
          }}
          transition={{
            delay: delaySeconds + 0.3,
            duration: 0.3,
            ease: "easeOut",
          }}
        >
          {label}
        </motion.div>
      </div>
    </div>
  );
}
